import { render, staticRenderFns } from "./user-lists.vue?vue&type=template&id=91f19d5e&scoped=true&"
import script from "./user-lists.vue?vue&type=script&lang=js&"
export * from "./user-lists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f19d5e",
  null
  
)

export default component.exports